import ModalViewModel from '../../infra/ModalViewModelSansDecorators'
import { makeObservable, computed } from 'mobx'
import WorkspaceOpportunityInvitationStore from './WorkspaceOpportunityInvitationStore'
import { task } from 'mobx-task'
import WorkspaceInvitation from './WorkspaceInvitation'
import { Id } from '../../types/definitions'

/**
 * View Model for the Workspace Invitation Modal
 */
export class WorkspaceInvitationModalViewModel extends ModalViewModel {
  constructor(
    private readonly _workspaceOpportunityInvitationStore: WorkspaceOpportunityInvitationStore,
    private readonly _workspaceOpportunity: WorkspaceInvitation,
  ) {
    super()
    makeObservable(this, {
      expirationMillis: computed,
      timeUntilExpiration: computed,
      software: computed,
      location: computed,
      description: computed,
      id: computed,
    })
  }

  accept = task.resolved(async () => {
    await this._workspaceOpportunityInvitationStore
      .acceptInvitation(Id.assert(this._workspaceOpportunity.id))
      .then(this.close)
  })

  reject = task.resolved(async () => {
    await this._workspaceOpportunityInvitationStore
      .rejectInvitation(Id.assert(this._workspaceOpportunity.id))
      .then(this.close)
  })

  /**
   * Id of the Workspace Posting
   */
  get id() {
    return this._workspaceOpportunity.id
  }

  /**
   * The date, expressed in milliseconds, at which the invitation expires
   */
  get expirationMillis() {
    return this._workspaceOpportunity.dateExpires.getTime()
  }

  /**
   * The time until the invitation expires
   */
  get timeUntilExpiration() {
    return this._workspaceOpportunity.timeUntilExpiration
  }

  /**
   * Formatted string of the software requirements for the Workspace Opportunity
   */
  get software() {
    if (this._workspaceOpportunity.supplementalSoftware) {
      return `${this._workspaceOpportunity.primarySoftware}, ${this._workspaceOpportunity.supplementalSoftware}`
    }
    return `${this._workspaceOpportunity.primarySoftware}`
  }

  /**
   * The designated location for the Workspace Opportunity
   */
  get location() {
    return this._workspaceOpportunity.location
  }

  /**
   * The description of the Workspace Opportunity
   */
  get description() {
    return this._workspaceOpportunity.description
  }

  /**
   * The list of specialties for the Workspace Opportunity
   */
  get specs() {
    return this._workspaceOpportunity.specialties
  }
}
